import { animate, style, transition, trigger } from '@angular/animations';
import { NgClass } from '@angular/common';
import { Component, ElementRef, inject } from '@angular/core';
import { AuthenticationStore } from '@pflegix/authentication';
import { TooltipModule } from 'primeng/tooltip';
import { LayoutService } from './service/app.layout.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-menu-profile',
  templateUrl: './app.menuprofile.component.html',
  imports: [NgClass, TooltipModule],
  animations: [
    trigger('menu', [
      transition('void => inline', [
        style({ height: 0 }),
        animate('400ms cubic-bezier(0.86, 0, 0.07, 1)', style({ opacity: 1, height: '*' })),
      ]),
      transition('inline => void', [
        animate('400ms cubic-bezier(0.86, 0, 0.07, 1)', style({ opacity: 0, height: '0' })),
      ]),
      transition('void => overlay', [
        style({ opacity: 0, transform: 'scaleY(0.8)' }),
        animate('.12s cubic-bezier(0, 0, 0.2, 1)'),
      ]),
      transition('overlay => void', [animate('.1s linear', style({ opacity: 0 }))]),
    ]),
  ],
})
export class AppMenuProfileComponent {
  private readonly layoutService = inject(LayoutService);
  public readonly el = inject(ElementRef);

  protected authStore = inject(AuthenticationStore);

  protected toggleMenu(): void {
    this.layoutService.onMenuProfileToggle();
  }

  public showConfigSidebar(): void {
    this.layoutService.showConfigSidebar();
  }

  protected get isHorizontal(): boolean {
    return this.layoutService.isHorizontal() && this.layoutService.isDesktop();
  }

  protected get menuProfileActive(): boolean {
    return this.layoutService.state.menuProfileActive;
  }

  protected get menuProfilePosition(): string {
    return this.layoutService.config().menuProfilePosition;
  }

  protected get isTooltipDisabled(): boolean {
    return !this.layoutService.isSlim();
  }

  protected logOut(): void {
    this.authStore.signOut();
  }
}
